import PaFormFields from "../../../shared/PaFormFields";
import {validationsMethods} from "../../../components/Pages/CreatePa/utils";

export const commonMethods = ([state,setState]) => {

    // loop through the validators for each field
    const getErrors = ({value, field, state}) => {

        const {label, validations, visibility, sanitize} = PaFormFields[field];
        const errors = [];
        if (state === undefined) {
            return false;
        }
        value = sanitize ? sanitize(value) : value
        const shouldVal = shouldValidate(visibility, validations, state, value);
        if (shouldVal) {
            validations.forEach(item => {

                // for validations that are strings, this means they are keys to one
                // of our hardcoded validation functions
                if (typeof item === 'string') {

                    /*
                     multiple methods can be grouped together in an "or" fashion
                     example ['!visible,required']
                     */

                    // split grouped methods
                    const methods = item.split('||');

                    // keep track of if a method returns true
                    let isValid = false;

                    // loop through each method
                    methods.forEach(method => {

                        // if a group of methods is already invalid skip the rest
                        if (!isValid) {

                            let comparedFields
                            let comparedValues
                            let comparedLables
                            /*
                                Methods can contain field names to compare
                            */
                            if (method.includes('_')) {
                                comparedFields = method.split('_').slice(1)
                                comparedLables = comparedFields.map(field => PaFormFields[field].label)
                                comparedValues = comparedFields.map(field => {
                                    return state.fields[field].value
                                })

                                /* Extract method name out */
                                method = method.split('_')[0]
                            }

                            /*
                            methods can be set to NOT by adding ! to the method
                            example ['!visible']
                             */
                            let isNot = false;

                            if (method.startsWith('!')) {
                                method = method.slice(1, -1)
                                isNot = true;
                            }

                            if (validationsMethods[method]) {
                                const isValidFn = validationsMethods[method].isValid;
                                const getErrorMsg = validationsMethods[method].getErrorMsg;

                                // if method is not reverse it
                                isValid = isNot ? !isValidFn(value, comparedValues) : isValidFn(value, comparedValues);

                                // if not valid add the error message
                                if (typeof isValid === 'boolean' && !isValid) {
                                    errors.push(getErrorMsg(label, comparedLables))
                                } else if (isValid && isValid.errors && isValid.errors.length) {
                                    errors.push(...isValid.errors)
                                }
                            }
                        }
                    });
                } else {
                    const {valid, msg} = item(value)
                    if (!valid) {
                        errors.push(msg)
                    }
                }
            })
        }
        return errors;
    }

    const isValidAuthNumber = () => {
        const {authNumber} = state;
        const regex = /[a-zA-Z0-9]/g;
        return authNumber
            && authNumber.match(regex) !== null
            && authNumber.match(regex).length === authNumber.length;
    }
    const setAuthNumber = authNumber => {
        setState(prev => ({
            ...prev,
            authNumber
        }))
    }

    const getSanitizedValue = (value, key) => value && PaFormFields[key].sanitize ? PaFormFields[key].sanitize(value) : value;

    /*
    set 1 or more fields in the context
    example 1: Update Value Only
        setFields({textBox: '12345678'})

    example 2: Update other properties
        setFields({selectBox: { value: '12345678', isDirty: true, options: ['value 1', value 2], errors: ['Is Required.'], hasErrors: true}})

    Example 3: Update multiple fields
        const change = {
        textBox: '12345678',
        selectBox: { value: '12345678', isDirty: true, options: ['value 1', value 2], errors: ['Is Required.'], hasErrors: true}
        };
        setFields(change)
    */
    const setFields = (fields, cb=null) => {

        if (!fields) return;
        const keys = Object.keys(fields);
        if (!keys.length) return;

        setState( prev => {
            // deep copy previos fields
            const newFields = {}
            for (let field in prev.fields) {
                newFields[field] = {}
                for (let property in prev.fields[field]) {
                    newFields[field][property] = prev.fields[field][property];
                }
            }

            // change according to fields param
            for (let key in fields) {
                // if the field is an object
                if (
                    fields[key] !== null
                    && fields[key] !== undefined  // make sure the value is not null or undefined
                    && typeof fields[key] === 'object'  // make sure the value is an object
                    && fields[key].push === undefined   // this checks that it is not an array
                ){
                    for (let property in fields[key]) {
                        newFields[key][property] = fields[key][property];
                    }
                } else {
                    newFields[key].value = fields[key];
                }
                const errors = getErrors({value: newFields[key].value, field: key, state});
                newFields[key].hasValue =   newFields[key].value !== '' &&
                                            newFields[key].value !== null &&
                                            newFields[key].value !== undefined  
                newFields[key].errors  = errors;
                newFields[key].isValid = errors.length === 0;
                newFields[key].value = getSanitizedValue(newFields[key].value, key);
            }

            return {
                ...prev,
                cb,
                fields: newFields
            }
        });
    }

    const setOperation = (operation, authNumber) => {
        if (!operation){
            return;
        }
        setState(prev => {
            const newState = {
                ...prev,
                operation
            }

            if (authNumber) {
                newState.authNumber = authNumber
            }
            return newState;
        })
    }

    const shouldValidate = (visibility, validations, state, value) => {
        const isRequired = validations ? validations.some(v => v === 'required') : false
        if (!isRequired && !value) return false
        if (!validations || validations.length === 0) return false;
        if (!visibility) return true;
        return visibility(state.fields);
    }
    const setBanner = bannerProps => {
        window.scrollTo(0,0);
        setState(prev => {
            return {
                ...prev,
                bannerProps
            }
        })
    }
    const setStatus = status => {
        setState(prev => {
            return{
                ...prev,
                status
            }
        })
    }

    const setModalState = params => {
        setState( prev => {
            const newUpdate = {
                ...prev,
                modalState: {
                    ...prev.modalState,
                    ...params
                }
            }

            return newUpdate;
        })
    }

    const resetFields = _cleanFields => {
        if(_cleanFields.length === 0) return
        const cleanFields = typeof _cleanFields === 'string' ? [_cleanFields] : _cleanFields
        setState( prev => {
            const newState = {...prev, fields: {...prev.fields}}
            cleanFields.forEach( cleanField => {
                newState.fields[cleanField].errors = []
                newState.fields[cleanField].value = ''
                newState.fields[cleanField].isDirty = false
                newState.fields[cleanField].isValid = false
            })
            return newState
        })
    }

    return {
        getErrors,
        resetFields,
        isValidAuthNumber,
        setAuthNumber,
        setFields,
        shouldValidate,
        setOperation,
        setBanner,
        setStatus,
        setModalState
    }
}